import { defineStore } from 'pinia';
import { computed } from 'vue';
import { useEntityStore } from '../../common/composables/entityStore';
import type { Packaging } from '../domain/packaging';

export const usePackagingStore = defineStore('packaging', () => {
  const { add, getById, clear, merge, remove, changed, getOrThrow, list } =
    useEntityStore<Packaging>({
      eventName: 'packaging-changed',
      getEntityId(entity) {
        return entity.id;
      },
      updateEntity(dest, src) {
        dest.name = src.name;
        dest.description = src.description;
        dest.level = src.level;
      },
      hasChanged(existing, incoming) {
        return JSON.stringify(existing) !== JSON.stringify(incoming);
      },
    });

  return {
    changed,
    getById,
    add,
    remove,
    getOrThrow,
    merge,
    clear,
    packaging: computed(() =>  list.value),
    sortedByName: computed(() => {
      const clone = Array.from(list.value);
      clone.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }));
      return clone;
    }),
  };
});
